import { useState } from 'react';
import { useUnmount } from 'ahooks';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { DPS_REPORT_STORAGE_KEY } from '@gp/constants/storageKeys';

import type { IDPSReportBaseVO } from '@gp/types/dpsReport/common';

const getStorageReports = (): IDPSReportBaseVO[] => {
  const reportsTmp = storage.getSessionStorageItem(DPS_REPORT_STORAGE_KEY.DPS_REPORT_REPORTS_SUMMARY_STORAGE_KEY);
  return Array.isArray(reportsTmp) ? reportsTmp : [];
};

export default function useDPSReportSession() {
  const [reports] = useState<IDPSReportBaseVO[]>(() => getStorageReports());

  useUnmount(() => {
    storage.removeSessionStorageItem(DPS_REPORT_STORAGE_KEY.DPS_REPORT_REPORTS_SUMMARY_STORAGE_KEY);
  });

  return reports;
}
